import { render, staticRenderFns } from "./alertBanner.vue?vue&type=template&id=89ba1c70"
var script = {}
import style0 from "./alertBanner.vue?vue&type=style&index=0&id=89ba1c70&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89ba1c70')) {
      api.createRecord('89ba1c70', component.options)
    } else {
      api.reload('89ba1c70', component.options)
    }
    module.hot.accept("./alertBanner.vue?vue&type=template&id=89ba1c70", function () {
      api.rerender('89ba1c70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/alertBanner.vue"
export default component.exports